import { z } from "zod";
import { timestamp } from "./timestamp";

export const dateOrFalse = z.union([z.literal(false), timestamp]);
